module.exports = __webpack_public_path__ + "img/backup_restore_languages.6e34253f.svg";